import { faDownload, faEdit, faMicrophone } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { Badge, Card, Col, Row } from "react-bootstrap";
import { Note } from "../../../../types/note";
import IconButton from "../../../ui/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "react-tooltip";

interface ContactViewState {
  n: Note;
  setEdit: any;
  setCurrent: any;
  downloadReport: any;
  setReportType: any;
}

const ContactView = ({ n, setEdit, setCurrent, downloadReport, setReportType }: ContactViewState) => {
  const [running, setRunning] = useState<boolean>(false);

  const onClickEdit = () => {
    setEdit(true);
    setCurrent(n);
  };

  const onClickDownload = async (e: any) => {
    e.stopPropagation();
    setRunning(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));

    setReportType("Contact");
    const download = await downloadReport(e, n);
    setRunning(false);
  };
  return (
    <Card id={"note-card-" + n?.id} className="bg-light mb-3 cursor-pointer" onClick={(e) => onClickEdit()}>
      <Card.Body>
        <>
          <Row className="mb-0">
            <Col>
              <h5 className="app-orange-text">Contact</h5>
            </Col>
            <Col className="text-end">
              {(n.fields.visit_hour || n.fields.visit_min) && (
                <label className="text-muted me-3">
                  {n.fields.visit_hour ? n.fields.visit_hour : "0"} hour(s) {n.fields.visit_min ? n.fields.visit_min : "0"} minute(s)
                </label>
              )}
              {n.fields.date && <label className="note-type text-muted me-3">{n.fields.date}</label>}
              <FontAwesomeIcon
                data-tooltip-id={"note-download-tooltip-" + n?.id}
                data-tooltip-content="Download Note"
                id={"note-download-button-" + n?.id}
                className="text-muted cursor-pointer me-3"
                icon={faDownload}
                onClick={(e) => onClickDownload(e)}
              />
              <Tooltip id={"note-download-tooltip-" + n?.id} place="top" style={{ padding: "5px 10px" }} />
              <FontAwesomeIcon
                data-tooltip-id={"note-edit-tooltip-" + n?.id}
                data-tooltip-content="Edit Note"
                id={"note-edit-button-" + n?.id}
                className="text-muted cursor-pointer"
                icon={faEdit}
                onClick={(e) => onClickEdit()}
              />
              <Tooltip id={"note-edit-tooltip-" + n?.id} place="top" style={{ padding: "5px 10px" }} />
            </Col>
          </Row>
          <Row>
            <div
              id="capture-text"
              style={{
                height: running ? "auto" : "80px",
                pointerEvents: "none",
                backgroundColor: "#e9ecef",
                color: "#6c757d",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
                overflow: "hidden",
                border: "1px solid #ccc",
                padding: "5px",
              }}
            >
              {n.fields.summary_info ? n.fields.summary_info : ""}
            </div>
          </Row>
          <Row className="mt-1">
            <Col className="col-6 text-start">
              <Badge bg="secondary" className="me-3">
                Created By {n.firstname} {n.lastname}
              </Badge>
              {n?.recordingsExist === true && <IconButton tooltipText="Recordings Exist" icon={faMicrophone} />}
            </Col>
            <Col className="col-6 text-end">
              {n.subject?.room && (
                <Badge bg="secondary" className="me-2">
                  {n.subject?.room + " " + n.subject?.bed}
                </Badge>
              )}
              <Badge bg="secondary">{n.subject?.name}</Badge>
            </Col>
          </Row>
        </>
      </Card.Body>
    </Card>
  );
};

export default ContactView;
